module.exports = __webpack_public_path__ + "static/laboratorio_doctores_alvarez-8359bbc7095d5b73caf2099343cbc6fb.jpg";